import { createSlice } from "@reduxjs/toolkit"
import { persistReducer } from "redux-persist"
import storage from "redux-persist/lib/storage"

import { logout } from "../../Containers/LoginPage/redux/auth.actions"
import { NAV_SLICE_NAME } from "./nav.constants"

const readPersistedTheme = () =>
  localStorage.getItem("chargebackTheme") ? localStorage.getItem("chargebackTheme") : "light"

const readPersistedIncognito = () => localStorage.getItem("chargebackIncognito") === "true"

const initialState = {
  isDesktop: false,
  showConfirm: null,
  isMobile: false,
  isShowMenu: false,
  isShowSideBar: true,
  tabPosition: { x: 0, y: 0 },
  theme: readPersistedTheme(),
  incognito: readPersistedIncognito(),
  disabledTransition: false
}

const slice = createSlice({
  name: NAV_SLICE_NAME,
  initialState,
  reducers: {
    navSetProp(state, action) {
      const { key, value } = action.payload

      if (key === "theme") {
        localStorage.setItem("chargebackTheme", value)
        document.body.style.backgroundColor = value === "dark" ? "#030625" : "#ffffff"
        document
          .querySelector('meta[name="theme-color"]')
          .setAttribute("content", value === "dark" ? "#030625" : "#ffffff")
      }

      if (key === "incognito") {
        localStorage.setItem("chargebackIncognito", value ? "true" : "false")
      }

      state[key] = value
    }
  },
  extraReducers: (builder) => {
    // Shared LOGOUT action. Theme and Incognito are deliberately re-read from localStorage
    // instead of falling back to `initialState`, so both survive logging out.
    builder.addCase(logout, () => ({
      ...initialState,
      theme: readPersistedTheme(),
      incognito: readPersistedIncognito()
    }))
  }
})

export const navActions = slice.actions

const PERSISTED_REDUCER_VERSION = 2

export const persistedReducer = persistReducer(
  {
    key: NAV_SLICE_NAME,
    storage,
    version: PERSISTED_REDUCER_VERSION,
    migrate: async (state) => {
      if (state?._persist?.version < PERSISTED_REDUCER_VERSION) {
        return {
          ...state,
          ...initialState
        }
      }
      return state
    }
  },
  slice.reducer
)

export const reducer = persistedReducer
